import { Edit, ListButton, TopToolbar, useRecordContext, useTranslate } from 'react-admin'
import { AppointmentForm, appointmentRelations } from '~/components'

const AppointmentName = (props) => {
  const record = useRecordContext(props)

  const translate = useTranslate()
  if (!record) return null
  // "Besichtigung: Probefahrt", or whichever of the two there is — a viewing
  // has no title of its own (choosing a type clears it).
  const parts = [
    record.type && translate(`resources.appointments.types.${record.type}`),
    record.title,
  ].filter(Boolean)
  return (
    <span>{parts.join(': ') || translate('resources.appointments.name', { smart_count: 1 })}</span>
  )
}

const AppointmentEditActions = ({ data }) => (
  <TopToolbar>
    <ListButton label='ra.action.back' />
  </TopToolbar>
)

export const AppointmentEdit = (props, record) => {
  return (
    <Edit
      title={<AppointmentName />}
      actions={<AppointmentEditActions />}
      {...props}
      transform={appointmentRelations}
      redirect='list'
    >
      <AppointmentForm />
    </Edit>
  )
}

export default AppointmentEdit
